import { historyModule } from '_core';

export const browserHistory = (historyModule as any).createBrowserHistory();
